import { IncomeModel, IncomeType, OwnerOptionsDTO } from './api/useIncomeQuery';
import { IncomeData } from './useIncome';
import { WorkflowComponentProps } from '../../Workflow/Workflow.meta';

export type IncomeToUpsert = IncomeModel | { Id?: string; IncomeType?: IncomeType; Name?: string };

export interface IncomeToDelete {
  id: string;
  name: string;
}

export interface IncomeTableProps {
  incomeType: IncomeType;
  clientId: string;
  data: IncomeData;
  setIncomeToUpsert: (incomeToUpsert: IncomeToUpsert | null) => void;
  setIncomeToDelete: (incomeToDelete: IncomeToDelete | null) => void;
  workflowProps?: WorkflowComponentProps;
}

export const ADD_INCOME_SUCCESS_MESSAGE = 'Income added successfully.';
export const EDIT_INCOME_SUCCESS_MESSAGE = 'Income saved successfully.';

export const getIncomeOwnerModel = ({
  value,
  options,
}: {
  value: string;
  options: OwnerOptionsDTO;
}) => {
  const selectedOwnerOption = Object.values(options)
    .map(item => item)
    .flat()
    .find(owner => owner.Name === value);
  return [
    {
      ...selectedOwnerOption,
      Id: selectedOwnerOption.Id,
      Name: selectedOwnerOption.Name,
      OwnerType: selectedOwnerOption.OwnerType,
      Percentage: 1,
    },
  ];
};
